export const getPersonDisplayName = (personTitle: unknown, name: unknown) => {
  const normalizedTitle =
    typeof personTitle === 'string' ? personTitle.replace(/\s+/g, ' ').trim() : ''
  const normalizedName = typeof name === 'string' ? name.replace(/\s+/g, ' ').trim() : ''

  if (!normalizedTitle || !normalizedName) {
    return normalizedTitle || normalizedName
  }

  const lowerCaseTitle = normalizedTitle.toLocaleLowerCase()
  const lowerCaseName = normalizedName.toLocaleLowerCase()

  if (lowerCaseName === lowerCaseTitle || lowerCaseName.startsWith(`${lowerCaseTitle} `)) {
    return normalizedName
  }

  return `${normalizedTitle} ${normalizedName}`
}


type FlattenedField<T, K extends keyof T> = T[K] extends (infer U)[]
  ? NonNullable<U>
  : NonNullable<T[K]>

export function flatten<T, K extends keyof T>(
  data: T[] | T[][],
  field: K
): Array<FlattenedField<T, K>> {
  const arr = data.some(Array.isArray) ? (data as T[][]).flat() : (data as T[])
  let intermediate: unknown[] = arr.map((item) => item[field]).filter(Boolean)
  if (intermediate.some(Array.isArray)) {
    intermediate = intermediate.flat()
  }
  return [...new Set(intermediate)] as Array<FlattenedField<T, K>>
}

export const mapProps = (data: Record<string, any>, mapping: Record<string, string>) => {
  return {
    ...Object.fromEntries(
      Object.entries(data).filter(([key]) => !Object.values(mapping).includes(key))
    ),
    ...Object.keys(mapping).reduce((acc: Record<string, any>, key: string) => {
      acc[key] = data[mapping[key]] ?? null
      return acc
    }, {}),
  }
}
